export default {
  ROJOU: 1,
  ROKA: 2,
  KOUKASHITA: 3,
}
